import { ActivatedRoute, Router } from '@angular/router';
import { HttpClientService } from '../../../../services/httpClient/httpclient.service';
import { MessageService } from 'primeng/components/common/api';
import { Component } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-json-schema-form',
  templateUrl: './json-schema-form.component.html',
  styleUrls: ['./json-schema-form.component.css']
})
export class JsonSchemaFormComponent {

  mySchema: any = {
    properties: {},
    required: [],
    order: []
  };
  myModel: any = {};
  configKey: string;
  id: number;
  appId: number;
  readonly = false;

  constructor(
    private http: HttpClientService,
    private route: ActivatedRoute,
    private router: Router,
    private srvNotify: MessageService,) {

    if (this.route.snapshot.paramMap.get('configKey')) {
      this.configKey = this.route.snapshot.paramMap.get('configKey');
    }

    if (this.route.snapshot.paramMap.get('configKey')) {
      this.appId = +this.route.snapshot.paramMap.get('appId');
    }

    if (this.route.snapshot.paramMap.get('readonly')) {
      this.readonly = true;
    }
    this.http.get('/koncentro-api/kwallet/getAppConfig?ui=1').subscribe(res => {
      res.rsp_data.forEach(r => {
        if (r.configKey === this.configKey && r.appId === this.appId) {
          this.id = r.id;
          //this.appId = r.appId;
          // Set Form Schema
          this.mySchema = {
            properties: { ...r.configTypeFormSchema.properties },
            required: r.configTypeFormSchema.required ? [...r.configTypeFormSchema.required] : [],
            order: r.configTypeFormSchema.order ? [...r.configTypeFormSchema.order] : [],
          };
          // Set Model
          const formValues = { ...r.configValue };
          for (let prop in this.mySchema.properties) {
            // Se readonly
            if (this.readonly && !this.mySchema.properties[prop].readOnly) {
              this.mySchema.properties[prop].readOnly = true;
            }
            // Conversione eventuali date
            if (this.mySchema.properties[prop].widget === "calendar" && formValues[prop]) {
              formValues[prop] = new Date(formValues[prop]);
            }
            // In caso di Api (in caso venga richiesto in futuro)
            if (this.mySchema.properties[prop].url) {
              const url: string = this.mySchema.properties[prop].url;
              const propLabel: string = this.mySchema.properties[prop].propLabel;
              const propValue: string = this.mySchema.properties[prop].propValue;
              this.http.get(url).subscribe(res => {
                res.forEach(r => {
                  formValues[prop].oneOf.push({
                    "label": r[`${propLabel}`],
                    "value": r[`${propValue}`]
                  });
                });
              })
            }
          }
          this.myModel = {...formValues};
        }
      })
    });
  }

  submitForm() {
    if(!document.forms[0].checkValidity()) {
      return;
    }
    for (let prop in this.myModel) {
      // Conversione eventuali date
      if (this.myModel[prop] instanceof Date) {
        this.myModel[prop] = moment(this.myModel[prop]).format('YYYY-MM-DD');
      }
    }
    const data = {
      appId: this.appId,
      configKey: this.configKey,
      configValue: this.myModel
    }
    this.http.put(`koncentro-common/apps-config/${this.id}`, data).subscribe(
      () => this.router.navigate(['/apps-config']),
      err => this.srvNotify.add({ severity: 'error', summary: 'Error!', detail: "Submission Failed"})
    );
  }

  goBack() {
    this.router.navigate(['/apps-config']);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/json-schema-form.component.ts